(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-effect"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dsc-black-friday-rain')) {
    customElements.define('dsc-black-friday-rain', class extends HTMLElement {
      static loadEngine() {
        this.enginePromise ||= import('https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.4/+esm')
          .then(module => module.default)
          .catch(error => {
            this.enginePromise = null;
            throw error;
          });

        return this.enginePromise;
      }

      connectedCallback() {
        this.controller?.abort();
        this.stop();
        this.controller = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.sessionKey = 'dsc-black-friday-snow-v2:' + this.dataset.sectionId;
        const options = { signal: this.controller.signal };

        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.stop();
        }, options);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
        }, options);

        window.addEventListener('pagehide', () => this.stop(), options);

        if (window.Shopify?.designMode) {
          this.closest('.shopify-section')?.addEventListener(
            'shopify:section:select', () => this.play(), options
          );
        }

        const schedule = () => {
          this.delay = window.setTimeout(() => this.play(), 600);
        };

        if (document.readyState === 'complete') {
          schedule();
        } else {
          window.addEventListener('load', schedule, { ...options, once: true });
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.stop();
      }

      async play() {
        this.stop();
        if (!this.isConnected || document.hidden || this.motion.matches) return;

        const editor = Boolean(window.Shopify?.designMode);

        if (!editor && this.dataset.once === 'true') {
          try {
            if (window.sessionStorage.getItem(this.sessionKey)) return;
          } catch {}
        }

        const run = this.run;
        let engine;

        try {
          engine = await this.constructor.loadEngine();
        } catch {
          return;
        }

        if (run !== this.run || !this.isConnected || document.hidden || this.motion.matches) return;

        const duration = Math.min(5, Math.max(2, Number(this.dataset.duration) || 4)) * 1000;
        const density = Math.min(80, Math.max(10, Number(this.dataset.density) || 30));
        const mobile = window.matchMedia('(max-width: 699px)').matches;
        const rate = density * (mobile ? 1.4 : 2);
        const colors = [this.dataset.colorOne || '#C9A34E', this.dataset.colorTwo || '#202020'];

        this.layer = document.createElement('canvas');
        this.layer.className = 'dsc-bf-rain';
        this.layer.style.width = '100%';
        this.layer.style.height = '100%';
        this.layer.setAttribute('aria-hidden', 'true');
        document.body.appendChild(this.layer);

        this.snow = engine.create(this.layer, {
          resize: true,
          useWorker: true,
          disableForReducedMotion: true
        });

        const started = performance.now();

        const emit = () => {
          const elapsed = performance.now() - started;
          if (elapsed >= duration) return;

          const progress = elapsed / duration;
          const verticalSpread = Math.max(0.8, 1 - elapsed * 0.00006);

          this.settled = this.snow({
            particleCount: 1,
            shapes: ['circle'],
            colors: [colors[Math.floor(Math.random() * colors.length)]],
            startVelocity: 0,
            ticks: Math.max(200, 500 * (1 - progress)),
            gravity: 0.4 + Math.random() * 0.2,
            scalar: 0.4 + Math.random() * 0.6,
            drift: Math.random() * 0.8 - 0.4,
            origin: {
              x: Math.random(),
              y: Math.random() * verticalSpread - 0.2
            }
          });
        };

        emit();
        this.emitter = window.setInterval(emit, 1000 / rate);

        this.finish = window.setTimeout(() => {
          window.clearInterval(this.emitter);
          this.emitter = null;

          Promise.resolve(this.settled).then(() => {
            if (run === this.run) this.stop();
          });
        }, duration);

        if (!editor && this.dataset.once === 'true') {
          try {
            window.sessionStorage.setItem(this.sessionKey, '1');
          } catch {}
        }
      }

      stop() {
        this.run = (this.run || 0) + 1;
        window.clearTimeout(this.delay);
        window.clearTimeout(this.finish);
        window.clearInterval(this.emitter);
        this.snow?.reset();
        this.snow = null;
        this.layer?.remove();
        this.layer = null;
        this.settled = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dsc-collection-cta')) {
    customElements.define('dsc-collection-cta', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;
        if (this.classList.contains('is-revealed')) return;

        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('is-revealed');
            this.observer.disconnect();
          }
        }, { threshold: 0.65 });

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-button"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dsc-whatsapp-button')) {
    customElements.define('dsc-whatsapp-button', class extends HTMLElement {
      connectedCallback() {
        this.mobile = window.matchMedia('(max-width: 699px)');
        this.bar = document.querySelector('product-sticky-bar');

        this.update = () => {
          const visible =
            this.mobile.matches &&
            this.bar?.classList.contains('is-visible');

          const lift = visible
            ? Math.ceil(this.bar.getBoundingClientRect().height)
            : 0;

          this.style.setProperty('--dsc-wa-lift', lift + 'px');
        };

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        window.addEventListener('resize', this.update, options);
        this.mobile.addEventListener('change', this.update, options);

        if (this.bar) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.bar);

          this.mutationObserver = new MutationObserver(this.update);
          this.mutationObserver.observe(this.bar, {
            attributes: true,
            attributeFilter: ['class']
          });
        }

        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
